export const formGroup = {
    id: {value: "", mandatory: true},
    bankName: {value: "", mandatory: true},
    accountNumber: {value: "", mandatory: true},
    accountName: {value: "", mandatory: true},
    kodeCabang: {value: null, mandatory: true},
};

export const tableColumns = [
    {
        name: "bankCode",
        label: "Kode Bank",
    },
    {
        name: "bankName",
        label: "Nama Bank",
    },
    {
        name: "accountNumber",
        label: "Nomor Rekening",
    },
    {
        name: "accountName",
        label: "Nama Rekening",
    }

];